var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabbed-editor-header-card',{staticClass:"purchase-order-header",attrs:{"title":_vm.title}},[_c('p',[_vm._v(_vm._s(_vm._f("dateFilter")(_vm.plannedDeliveryAt)))])])}
var staticRenderFns = []

export { render, staticRenderFns }